import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputItemSelection } from '../../../../../../shared/components/input-item-selection/input-item-selection';
import { ReportType } from '../../../../../../types/enums/report.enum';
import { InputItemSelectInterface } from '../../../../../../types/interfaces/input.interface';

@Component({
  selector: 'app-report-type',
  imports: [
    InputItemSelection,
  ],
  templateUrl: './report-type.html',
  styleUrl: './report-type.css',
})
export class ReportTypeStep {
  @Input()
  public canContinue: boolean = false;

  @Output()
  public nextClick: EventEmitter<void> = new EventEmitter<void>();

  public reportTypeConfig!: InputItemSelectInterface;

  private _reportForm: FormGroup | null = null;

  @Input()
  public set reportForm(reportForm: FormGroup) {
    this._reportForm = reportForm;
    this.reportTypeConfig = {
      formGroup: reportForm,
      label: 'common.fields.report-type',
      isTranslated: true,
      id: 'reportType',
      options: [
        {
          label: 'common.enum.report-type.' + ReportType.DEVICE,
          value: ReportType.DEVICE,
          icon: 'water_drop',
        },
        {
          label: 'common.enum.report-type.' + ReportType.DEVICE_DETAIL,
          value: ReportType.DEVICE_DETAIL,
          icon: 'water_drop',
        },
        {
          label: 'common.enum.report-type.' + ReportType.ALARM,
          value: ReportType.ALARM,
          icon: 'alarm',
        },
        {
          label: 'common.enum.report-type.' + ReportType.MEASUREMENT,
          value: ReportType.MEASUREMENT,
          icon: 'bar_chart_4_bars',
        },
        {
          label: 'common.enum.report-type.' + ReportType.LOG,
          value: ReportType.LOG,
          icon: 'docs',
        },
        {
          label: 'common.enum.report-type.' + ReportType.SIGI,
          value: ReportType.SIGI,
          icon: 'library_books',
        },
      ],
    };
  }

  public onTypeSelect(event: string): void {
    this._reportForm?.get('reportType')?.setValue(event);

    this.nextClick.emit();
  }
}
